<template>
	<div :class="classes" :style="styles" class="dashboard-card">
		<slot />
	</div>
</template>

<script>
export default {
	props: {
		styles: {
			type: Object,
			default() {
				return {};
			},
		},
		classes: Object,
	},
};
</script>

<style lang="scss">
.dashboard-card {
	background: #fff;
	border-radius: 5px;

	.toolbar,
	.content {
		display: block;
	}

	.toolbar {
		padding: 20px;
	}

	.content {
		padding: 0 20px 20px;
	}
}
</style>
